export const GET_COMMANDE_PACKS = "GET_COMMANDE_PACKS"
export const GET_COMMANDE_REJECTED_PACKS = "GET_COMMANDE_REJECTED_PACKS"
export const REJECT_COMMAND_PACK = "REJECT_COMMAND_PACK"
export const GET_UNIQUE_COMMANDE_PACK = "GET_UNIQUE_COMMANDE_PACK"
export const UPDATE_USER_PACK = "UPDATE_USER_PACK"